module.exports = __webpack_public_path__ + "static/media/gohighlevel.67b7e90b.svg";